import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/21-1_star.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const Star: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default Star;
